import { spawn } from 'redux-saga/effects';
import { sagas as listPublic } from './listPublicModule';

export default function* ipSagas() {
	yield spawn(listPublic);
}
